import { Typography } from "antd";
import Loader from "../CustomLoader/Loader";

const { Title } = Typography;

const ProfileSectionLayout = ({
  loading = false,
  title,
  header,
  children,
  withDetailsContainer = true,
}) => {
  if (loading) {
    return <Loader />;
  }

  return (
    <div className="investor-details-container">
      <div className="header-container">
        {header || <Title level={4}>{title}</Title>}
      </div>
      {withDetailsContainer ? (
        <div className="details-container">{children}</div>
      ) : (
        children
      )}
    </div>
  );
};

export default ProfileSectionLayout;
